import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import RatingScale from "../Anket/RatingScale";
import { toast } from "react-toastify";
import eventEmitter from "../../utils/eventEmitter";

const AnketOylamasi = ({ user }) => {
  const [ratings, setRatings] = useState({});
  const [userSkills, setUserSkills] = useState([]);

  useEffect(() => {
    const handleApiError = (error) => {
      console.error("API Error:", error);
      toast.error(error.message || "Bir hata oluştu");
    };

    eventEmitter.on("apiError", handleApiError);

    return () => {
      eventEmitter.off("apiError", handleApiError);
    };
  }, []);

  useEffect(() => {
    if (user?.data) {
      const newRatings = {};

      // totalRate kontrolü
      if (user.data.totalRate) {
        Object.entries(user.data.totalRate).forEach(([key, data]) => {
          if (data && typeof data.average === "number") {
            switch (key) {
              case "timeControl":
                newRatings["Zaman yönetimi ve iş teslimatları"] = data.average;
                break;
              case "communication":
                newRatings["İletişim ve takım çalışması"] = data.average;
                break;
              case "problemSolving":
                newRatings["Problem çözme ve yaratıcılık"] = data.average;
                break;
              case "improvement":
                newRatings["Geri bildirim ve kişisel gelişim"] = data.average;
                break;
              case "initiative":
                newRatings["Bağımsız Çalışabilme ve İnisiyatif"] = data.average;
                break;
            }
          }
        });
      }

      // Skills için rating kontrolü
      if (user.data.skillVotes) {
        Object.entries(user.data.skillVotes).forEach(([skillName, data]) => {
          if (data && typeof data.average === "number") {
            newRatings[skillName] = data.average;
          }
        });
      }

      setRatings(newRatings);

      // Skills state güncelleme
      if (user.data.skills && Array.isArray(user.data.skills)) {
        setUserSkills(user.data.skills);
      }
    }
  }, [user]);

  const handleRatingChange = (category, value) => {
    setRatings((prev) => ({
      ...prev,
      [category]: value,
    }));
  };

  if (!user?.data) {
    return <div className="pt-4 text-grayy">Veri bulunamadı.</div>;
  }

  const categories = [
    { id: 1, title: "Zaman yönetimi ve iş teslimatları" },
    { id: 2, title: "İletişim ve takım çalışması" },
    { id: 3, title: "Problem çözme ve yaratıcılık" },
    { id: 4, title: "Geri bildirim ve kişisel gelişim" },
    { id: 5, title: "Bağımsız Çalışabilme ve İnisiyatif" },
  ];

  return (
    <div>
      <div className="flex flex-col gap-4 divide-y-[1px] divide-lineGray">
        {categories.map((item) => (
          <div key={item.id} className="pt-2">
            <div className="flex justify-between">
              <h3 className="text-sm font-medium text-dark py-2">
                {item.id}. {item.title}
              </h3>
              <div className="min-w-[170px] sm:min-w-[270px]">
                <RatingScale
                  page="hesabim"
                  category={item.title}
                  selected={ratings[item.title] || 0}
                  handleRatingChange={handleRatingChange}
                  disabled={true}
                />
              </div>
            </div>
          </div>
        ))}

        <div className="pt-4">
          {userSkills.map((skill, index) => (
            <div
              key={skill._id || skill.name || `skill-${index}`}
              className="pl-4 flex justify-between items-center"
            >
              <p className="text-xs font-medium text-grayy py-1">
                • {skill.name}
              </p>
              <div className="min-w-[170px] sm:min-w-[270px]">
                <RatingScale
                  category={skill.name}
                  selected={ratings[skill.name] || 0}
                  handleRatingChange={handleRatingChange}
                  page="hesabim"
                  disabled={true}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnketOylamasi;
